import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "brand-detail-page" }
const _hoisted_2 = {
  key: 0,
  class: "loading-container"
}
const _hoisted_3 = {
  key: 1,
  class: "error-container"
}
const _hoisted_4 = {
  key: 2,
  class: "content-container"
}
const _hoisted_5 = { class: "brand-header" }
const _hoisted_6 = { class: "brand-basic-info" }
const _hoisted_7 = { class: "logo-section" }
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = {
  key: 0,
  class: "logo-badge"
}
const _hoisted_10 = { class: "brand-info" }
const _hoisted_11 = { class: "brand-name" }
const _hoisted_12 = { class: "brand-desc" }
const _hoisted_13 = { class: "brand-stats" }
const _hoisted_14 = { class: "stat-item" }
const _hoisted_15 = { class: "stat-number" }
const _hoisted_16 = { class: "stat-label" }
const _hoisted_17 = { class: "brand-time-info" }
const _hoisted_18 = { class: "time-item" }
const _hoisted_19 = { class: "time-content" }
const _hoisted_20 = { class: "time-label" }
const _hoisted_21 = { class: "time-value" }
const _hoisted_22 = {
  key: 0,
  class: "brand-story-section"
}
const _hoisted_23 = { class: "section-header" }
const _hoisted_24 = { class: "section-title" }
const _hoisted_25 = { class: "brand-story-content" }
const _hoisted_26 = {
  key: 1,
  class: "designers-section"
}
const _hoisted_27 = { class: "section-header" }
const _hoisted_28 = { class: "section-title" }
const _hoisted_29 = { class: "designer-card" }
const _hoisted_30 = ["src", "alt"]
const _hoisted_31 = { class: "designer-info" }
const _hoisted_32 = { class: "designer-name" }
const _hoisted_33 = { class: "designer-role" }
const _hoisted_34 = {
  key: 2,
  class: "products-section"
}
const _hoisted_35 = { class: "section-header" }
const _hoisted_36 = { class: "section-title" }
const _hoisted_37 = { class: "product-count" }
const _hoisted_38 = { class: "products-grid" }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { class: "product-image" }
const _hoisted_41 = ["src", "alt"]
const _hoisted_42 = {
  key: 0,
  class: "product-badge"
}
const _hoisted_43 = { class: "product-info" }
const _hoisted_44 = { class: "product-name" }
const _hoisted_45 = { class: "product-desc" }
const _hoisted_46 = { class: "product-price" }
const _hoisted_47 = {
  key: 0,
  class: "load-more"
}
const _hoisted_48 = { class: "verification-section" }
const _hoisted_49 = { class: "section-header" }
const _hoisted_50 = { class: "section-title" }
const _hoisted_51 = { class: "verification-content" }
const _hoisted_52 = { class: "verification-stats" }
const _hoisted_53 = { class: "verification-item" }
const _hoisted_54 = { class: "verification-info" }
const _hoisted_55 = { class: "verification-number" }
const _hoisted_56 = { class: "verification-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_loading = _resolveComponent("van-loading")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_empty = _resolveComponent("van-empty")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_swipe_item = _resolveComponent("van-swipe-item")!
  const _component_van_swipe = _resolveComponent("van-swipe")!
  const _component_van_tag = _resolveComponent("van-tag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      title: $setup.brandData?.name || _ctx.$t('brands.detail'),
      "left-arrow": "",
      fixed: "",
      placeholder: "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
    }, null, 8, ["title"]),
    ($setup.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_van_loading, {
            size: "24px",
            vertical: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('brands.loading')), 1)
            ]),
            _: 1
          })
        ]))
      : ($setup.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_van_empty, {
              description: _ctx.$t('brands.loadFailed'),
              image: "error"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_button, {
                  round: "",
                  type: "primary",
                  onClick: _ctx.fetchBrandDetail
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('brands.retry')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            }, 8, ["description"])
          ]))
        : ($setup.brandData)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("img", {
                      src: $setup.brandData.logo,
                      alt: $setup.brandData.name,
                      class: "brand-logo",
                      onLoad: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.handleLogoLoad && $setup.handleLogoLoad(...args))),
                      onError: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.handleLogoError && $setup.handleLogoError(...args)))
                    }, null, 40, _hoisted_8),
                    ($setup.brandData.status === 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _createVNode(_component_van_icon, { name: "certificate" }),
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t('brands.verified')), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("h1", _hoisted_11, _toDisplayString($setup.brandData.name), 1),
                    _createElementVNode("p", _hoisted_12, _toDisplayString($setup.brandData.desc), 1),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, _toDisplayString($setup.formatNumber($setup.brandData.productCount)), 1),
                        _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('brands.products')), 1)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_van_icon, {
                      name: "clock-o",
                      class: "time-icon"
                    }),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('brands.establishTime')), 1),
                      _createElementVNode("div", _hoisted_21, _toDisplayString($setup.formatDate($setup.brandData.establishTime)), 1)
                    ])
                  ])
                ])
              ]),
              ($setup.brandData.brandStory)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createVNode(_component_van_icon, {
                        name: "book",
                        class: "section-icon"
                      }),
                      _createElementVNode("h2", _hoisted_24, _toDisplayString(_ctx.$t('brands.story')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("p", null, _toDisplayString($setup.brandData.brandStory), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              ($setup.brandData.designers && $setup.brandData.designers.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _createVNode(_component_van_icon, {
                        name: "friends",
                        class: "section-icon"
                      }),
                      _createElementVNode("h2", _hoisted_28, _toDisplayString(_ctx.$t('brands.designers')), 1)
                    ]),
                    _createVNode(_component_van_swipe, {
                      class: "designers-swipe",
                      loop: false,
                      width: 120,
                      "show-indicators": false
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.brandData.designers, (designer) => {
                          return (_openBlock(), _createBlock(_component_van_swipe_item, {
                            key: designer.id,
                            class: "designer-item"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_29, [
                                _createElementVNode("img", {
                                  src: designer.avatar,
                                  alt: designer.name,
                                  class: "designer-avatar"
                                }, null, 8, _hoisted_30),
                                _createElementVNode("div", _hoisted_31, [
                                  _createElementVNode("h4", _hoisted_32, _toDisplayString(designer.name), 1),
                                  _createElementVNode("p", _hoisted_33, _toDisplayString(designer.role), 1)
                                ])
                              ])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              false
                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _createVNode(_component_van_icon, {
                        name: "bag",
                        class: "section-icon"
                      }),
                      _createElementVNode("h2", _hoisted_36, _toDisplayString(_ctx.$t('brands.products')), 1),
                      _createElementVNode("span", _hoisted_37, _toDisplayString($setup.brandData.productCount) + " " + _toDisplayString(_ctx.$t('brands.items')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.productsList, (product) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: product.id,
                          class: "product-card",
                          onClick: ($event: any) => ($setup.goToProductDetail(product.id))
                        }, [
                          _createElementVNode("div", _hoisted_40, [
                            _createElementVNode("img", {
                              src: product.image,
                              alt: product.name
                            }, null, 8, _hoisted_41),
                            (product.isNew)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                  _createVNode(_component_van_tag, {
                                    type: "danger",
                                    size: "small"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t('brands.new')), 1)
                                    ]),
                                    _: 1
                                  })
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_43, [
                            _createElementVNode("h4", _hoisted_44, _toDisplayString(product.name), 1),
                            _createElementVNode("p", _hoisted_45, _toDisplayString(product.description), 1),
                            _createElementVNode("div", _hoisted_46, " ¥" + _toDisplayString(product.price), 1)
                          ])
                        ], 8, _hoisted_39))
                      }), 128))
                    ]),
                    ($setup.hasMoreProducts)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                          _createVNode(_component_van_button, {
                            round: "",
                            type: "primary",
                            loading: _ctx.loadingMore,
                            class: "load-more-btn",
                            onClick: $setup.loadMoreProducts
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('brand.loadMore')), 1)
                            ]),
                            _: 1
                          }, 8, ["loading", "onClick"])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("div", _hoisted_49, [
                  _createVNode(_component_van_icon, {
                    name: "shield",
                    class: "section-icon"
                  }),
                  _createElementVNode("h2", _hoisted_50, _toDisplayString(_ctx.$t('brands.verification')), 1)
                ]),
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("div", _hoisted_52, [
                    _createElementVNode("div", _hoisted_53, [
                      _createVNode(_component_van_icon, {
                        name: "certificate",
                        class: "verification-icon"
                      }),
                      _createElementVNode("div", _hoisted_54, [
                        _createElementVNode("div", _hoisted_55, _toDisplayString($setup.brandData.verificationCount), 1),
                        _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.$t('brands.totalVerifications')), 1)
                      ])
                    ])
                  ])
                ])
              ]),
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "bottom-actions" }, null, -1))
            ]))
          : _createCommentVNode("", true)
  ]))
}